<template>
  <div class="footer">
    <div class="content">
      <div>
        <p class="title">友情链接</p>
        <div class="w_block" />
        <ul class="ins_list">
          <li v-for="(item,index) in infoList.friUrl" :key="index">
            <a target="_blank" :href="item.url">{{ item.title }}</a>
          </li>
        </ul>
      </div>
      <div class="contact_us">
        <p class="title">联系我们</p>
        <div class="w_block" />
        <p v-for="(item,index) in infoList.contactList" :key="index" class="filing">
          <img v-if="item.iconUrl" :src="baseUrl + item.iconUrl" alt="">
          <span v-if="item.title">{{ item.title }}：</span>{{ item.remark }}
        </p>
      </div>
      <div>
        <p class="title">关注我们</p>
        <div class="w_block" />
        <div>
          <img class="qd_code" :src="baseUrl + infoList.codeUrl" alt="">
          <p>扫一扫，关注我们</p>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    infoList: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      baseUrl: '/website'
    }
  }
}
</script>
<style lang="scss" scoped>
.footer{
  background-color: #24242E;
  padding: 30px 0 50px 0;
  display: inline-table!important;
  width: 100%!important;
}
.content{
  display: flex;
  justify-content: space-around;
  width: 1200px;
  margin: 0 auto;
  color: #fff;
  .contact_us{
    p{
      margin-bottom: 10px;
    }
    .filing{
      display: flex;
      align-items: center;
      img{
        margin-right: 10px;
      }
    }
  }
  &>div{
    width: 33%;
    padding: 0 30px;
    border-right: 1px solid #4D4D52;
    font-size: 16px;
    .title{
      font-size: 24px;
      margin-bottom: 11px;
    }
    .w_block{
      width: 53px;
      height: 4px;
      margin-bottom: 35px;
      background-color: #fff;
    }
    .qd_code{
      width: 122px;
      height: 122px;
      background-color: #fff;
      margin-bottom: 10px;
    }
    .ins_list{
      display: flex;
      flex-wrap: wrap;
      li{
        margin-bottom: 10px;
        margin-right: 20px;
        a{
          color: #fff;
        }
      }
    }
    &:last-child{
      border: none;
    }
  }
}
</style>
